module.exports = __webpack_public_path__ + "static/Laura-80100ce80e991dc5a3f2a532b465a53a.png";